import gsap from "gsap";

/**
 * External Dependencies
 */


// Select all links with hashes
jQuery('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function (event) {
        // On-page links
        if (
            location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
            location.hostname == this.hostname
        ) {
            // Figure out element to scroll to
            var target = jQuery(this.hash);
            target = target.length ? target : jQuery('[name=' + this.hash.slice(1) + ']');
            // Does a scroll target exist?
            if (target.length) {
                // Only prevent default if animation is actually gonna happen
                event.preventDefault();
                jQuery('html, body').animate({
                    scrollTop: target.offset().top
                }, 1000, function () {
                    // Callback after animation
                    // Must change focus!
                    var jQuerytarget = jQuery(target);
                    jQuerytarget.focus();
                    if (jQuerytarget.is(":focus")) { // Checking if the target was focused
                        return false;
                    } else {
                        jQuerytarget.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                        jQuerytarget.focus(); // Set focus again
                    };
                });
            }
        }
    });






/**
 * Nav > Menu Hamburger > Show/hide
 */
jQuery('header.containMenu nav.mobile.menu span.toggleMenuMobile').on('click', function () {
    jQuery('header.containMenu nav.mobile.menu.deployed').slideDown();
})

jQuery('header.containMenu nav.mobile.menu.deployed span.actionClose').on('click', function () {
    jQuery('header.containMenu nav.mobile.menu.deployed').slideUp();
})






/**
 * BLOC - EntêteDePage - Slider
 */

import Swiper from 'swiper/bundle';
var mySwiper = new Swiper('.swiper-container', {
    direction: 'horizontal',
    loop: true,
    speed: 1100,
    parallax: true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
            return '<span class="' + className + ' cursor-pointer w-4 mb-3 dot"></span>';
        },
    },
    autoplay: {
        delay: 4000,
    },
})






/**
 * BLOC - Icônes
 */

const swiper = new Swiper('.icones-swiper-container', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    speed: 1100,
    parallax: true,
    autoplay: {
        delay: 4000,
    },
    // If we need pagination
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    }
});






/**
 * BLOC - Thumbnails
 */

var thumbSwiper = new Swiper('.thumbnails-swiper-container, .articles-vedettes-swiper-container', {
    slidesPerView: 3,
    spaceBetween: 30,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    // Responsive breakpoints
    breakpoints: {
        // when window width is >= 480px
        0: {
            slidesPerView: 1,
            spaceBetween: 30
        },
        // when window width is >= 640px
        640: {
            slidesPerView: 2,
            spaceBetween: 50
        },
        // when window width is >= 1024px
        1024: {
            slidesPerView: 3,
            spaceBetween: 50
        }
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    loop: true
});






/**
 * BLOC - Liste partenaires
 */

var thumbSwiper = new Swiper('.partenaires-swiper-container', {
    slidesPerView: 3,
    spaceBetween: 30,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    // Responsive breakpoints
    breakpoints: {
        // when window width is >= 480px
        0: {
            slidesPerView: 1,
            spaceBetween: 30
        },
        // when window width is >= 640px
        640: {
            slidesPerView: 2,
            spaceBetween: 50
        },
        // when window width is >= 1024px
        800: {
            slidesPerView: 4,
            spaceBetween: 50
        }
    },
    navigation: {
        // nextEl: '.swiper-button-next',
        // prevEl: '.swiper-button-prev',
    }
});






/**
 * BLOC - Schéma séquentiel
 */

function giveHeightToTheConnector() {
    jQuery('div.acf-schema-sequentiel div.connector').each(function () {

        /* Get 'height' from the parent, .bloc */
        let heightParent = jQuery(this).closest('div.bloc').innerHeight()

        /* Get 'padding-bottom' from the parent, .bloc ... ? */

        /* Apply the height to the connector */
        jQuery(this).height(heightParent)

    })
}

window.addEventListener("resize", function () {
    giveHeightToTheConnector();
});

giveHeightToTheConnector();






/**
 * BLOG - MOBILE - Menu
 */

// Chargement de la page en fonction du choix
jQuery('select#blogMenuMobile').on('change', function () {
    let selectedCategoryUrl = jQuery(this).find('option:selected').val();
    window.location.href = selectedCategoryUrl;
})






/**
 * GSAP
 */

// Déclaration de ScrollTrigger
gsap.registerPlugin(ScrollTrigger);

// Exemple
/* gsap.from('footer', {
    scrollTrigger: 'footer',
    opacity: 0,
    duration: 10,
    scale: 0
})
*/


/* GSAP - ANIMATIONS */

// fadeIn au chargement d'une page
let fadePage = gsap.from('body', {
    opacity: 0,
    duration: 1
})

// Éléments du header
gsap.from('header div#logo-header, div.subscribeButtonContainer, nav.menu.main', {
    y: "-100%",
    duration: 1,
    stagger: 0.4,
    autoAlpha: 0
})

// Page d'accueil > Apparition des différentes catégories de formation
gsap.from('body.home nav.categories ul li', {
    stagger: 0.3,
    x: "-100%",
    duration: 1.3,
    autoAlpha: 0
}, 0.8)

// Animation des éléments individuels
let members = gsap.utils.toArray(["section.content, p:not(.no-anim)", "h1:not(.no-anim)", "h2:not(.no-anim)", "h3:not(.no-anim)", "h4:not(.no-anim)", "div.buttonAnimateSVG:not(.no-anim)"])
members.forEach(member => {
    gsap.from(member, {
        scrollTrigger: member,
        opacity: 0,
        y: -35,
        duration: 0.8
    })
})


// PAGE D'ACCUEIL

function home_css_adjustment() {
    // Aligne les éléments de gauche, ne se trouvant pas dans une classe "container" de Bootstrap
    // sur la même ligne que les éléments se trouvant dans une classe "container de Bootstrap
    var marginLeft = jQuery("div.container").css("margin-left");
    var paddingLeft = jQuery("div.container").css("padding-left");
    var totalLeft = (parseInt(marginLeft) + parseInt(paddingLeft));
    // Element aligné : "Vos conférenciers vedettes"
    jQuery('body.home section.conferenciers-vedettes section.title').css({
        "margin-left": marginLeft,
        "padding-left": paddingLeft
    });

    // Portraits conférenciers - On donne automatiquement la largeur de .item à .content (qui est en 'absolute')
    jQuery("section.conferenciers-vedettes .item").each(function () {
        let widthParent = jQuery(this).innerWidth();
        jQuery(this).find("section.content").innerWidth(Math.round(widthParent));
    });
}

function infolettre_css_adjustment() {
    // Ce qu'on veut faire, c'est récupérer la hauteur du bloc de contenu de la newsletter, lui rajouter en permanence son padding
    // haut et bas, cumuler le tout, et dire : voilà la hauteur du bloc infolettre à chaque resize

    let blocHeight = parseInt(jQuery("div.infolettre div.container").outerHeight());
    let paddingBloc = parseInt(jQuery("div.infolettre div.container").css("padding"));

    jQuery("div.infolettre").outerHeight(blocHeight + paddingBloc);
}

function GravityFormsSubmitCustomPosition() {
    jQuery("div.bloc-form-contact input#gform_submit_button_1").appendTo("div.ginput_container_textarea");
}

GravityFormsSubmitCustomPosition();
home_css_adjustment();
infolettre_css_adjustment();

jQuery(window).resize(function () {
    home_css_adjustment();
    infolettre_css_adjustment();
});

// Caroussel - Témoignages
if (jQuery('.temoignages-items.slider-nav').length > 0) {
    jQuery('.temoignages-items.slider-nav').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        centerMode: true,
        focusOnSelect: true,
        variableWidth: true
    });
}

// Caroussel - Logos partenaires
if (jQuery('.logos-items.slider-nav').length > 0) {
    jQuery('.logos-items.slider-nav').slick({
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        centerMode: true,
        focusOnSelect: true,
        variableWidth: true,
        autoplay: true,
        autoplaySpeed: 2000
    });
}


// NAV - MENU BURGER
let bars = document.querySelector('section.bars')
let bar1 = document.querySelector('.bar1')
let bar2 = document.querySelector('.bar2')
let bar3 = document.querySelector('.bar3')

// Ouverture du menu
bars.addEventListener('click', () => {
    bars.classList.toggle("anim")
    setTimeout(() => {

        gsap.to("nav.menuDeployed", {
            duration: 0.6,
            x: "0"
        })

        /* gsap.from('nav.menuDeployed div.logoContainer, nav.menuDeployed div.mx-auto.container', {
            opacity: 0,
            duration: 1,
            x: "-100%",
            stagger: 0.3
        }) */

    }, 200)
    setTimeout(() => {
        bars.classList.toggle("anim")
    }, 1000)
})


// Fermeture du menu
let windowMenu = document.querySelector("nav.menuDeployed")
let closeIcon = document.querySelector("span.closeMenuDeployed")

closeIcon.addEventListener("click", (e) => {
    gsap.to(windowMenu, {
        duration: 0.6,
        x: "-100%"
    })
})

/* ----------------------------------
 SUPPRESSION DES PARAGRAPHES VIDES
-----------------------------------*/

document.querySelectorAll("p").forEach((paragraph) => {
    // Si le paragraphe est vide, on le supprime.
    if (paragraph.innerHTML == "")
        paragraph.remove()
})